// extracted by mini-css-extract-plugin
module.exports = {"x404":"x404_x404__2SemM","Btns":"x404_Btns__-P_PM"};